import React from "react";

const LeftOffset = ({ children, style = {} }) => (
  <div className={"offset-left-subpanel"} style={style}>
    {children}
  </div>
);

export default LeftOffset;
